import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { SavedLayout } from '../hooks/useLayoutStorage';

interface LoadLayoutConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedLayout: SavedLayout | null;
}

export const LoadLayoutConfirmDialog = ({ open, onClose, onConfirm, selectedLayout }: LoadLayoutConfirmDialogProps) => {
  if (!selectedLayout) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Layout Load</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to load the layout "{selectedLayout.name}"?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This will replace the current dashboard layout and widget positions. This action cannot be undone.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Load Layout
        </Button>
      </DialogActions>
    </Dialog>
  );
};
